import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReportsService } from 'src/app/_services/reports.service';

@Component({
  selector: 'app-product-report',
  templateUrl: './product-report.component.html',
  styles: [
    `
      .no-data {
        text-align: left;
        border: 1px solid #e9ecef !important;
        border-width: 0 0 1px 0;
        padding: 1rem 1rem;
        color: #495057;
      }
    `,
  ],
  providers: [DatePipe],
})
export class ProductReportComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  productData = [];
  subscriptions: Subscription[] = [];
  form: FormGroup;
  allProducts: any;

  showMoreInfo = false;
  showMaxInfo = false;
  showMinInfo = false;
  showAvgInfo = false;

  dataInfo: any;
  productionInfo: any;

  constructor(
    private reportsService: ReportsService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      date_from: ['', Validators.required],
      date_to: ['', Validators.required],
      productId: ['', Validators.required],
    });

    this.getProducts();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(productId, dateFrom, dateTo) {
    this.loading = true;
    this.productData = [];
    this.subscriptions.push(
      this.reportsService
        .getProductReport(productId, dateFrom, dateTo)
        .subscribe((responseData: any) => {
          this.productData.push(responseData);

          this.productData[0].maxTimeHeader =
            'Maksimalno vreme izrade [min/kom]';
          this.productData[0].minTimeHeader =
            'Minimalno vreme izrade [min/kom]';
          this.productData[0].averageTimeHeader = 'Prosečno vreme izrade';
          this.productData[0].mediocrityHeader = 'Sredjenost procesa';

          this.productData[0].summaryArray = [responseData.summary];
          this.loading = false;
        })
    );
  }

  onSearch() {
    const form = this.form.getRawValue();

    if (this.form.valid) {
      form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
      form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

      this.getData(form.productId, form.date_from, form.date_to);
    }
  }

  onExportPdf() {
    const form = this.form.getRawValue();

    form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
    form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

    this.subscriptions.push(
      this.reportsService
        .exportProductToPDF(form.productId, form.date_from, form.date_to)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
        })
    );
  }

  onExportCsv() {
    const form = this.form.getRawValue();

    form.date_from = this.datePipe.transform(form.date_from, 'yyyy-MM-dd');
    form.date_to = this.datePipe.transform(form.date_to, 'yyyy-MM-dd');

    this.subscriptions.push(
      this.reportsService
        .exportProductToCSV(form.productId, form.date_from, form.date_to)
        .subscribe((pdfHref) => {
          window.open(pdfHref.data, '_blank');
        })
    );
  }
  /* ====================================
   *             HELPERS
   ======================================= */
  clearFilters(controlName) {
    this.form.get(controlName).setValue('');
  }

  getProducts() {
    this.loading = true;
    this.subscriptions.push(
      this.reportsService.getAllProducts().subscribe((products: any) => {
        this.allProducts = products.data;
      })
    );
  }

  onShowMoreInfo(data) {
    this.showMoreInfo = true;
    this.dataInfo = [data];
  }

  onShowMinMaxInfo(data, dialogName) {
    if (dialogName === 'max') {
      this.showMaxInfo = true;
    }

    if (dialogName === 'min') {
      this.showMinInfo = true;
    }

    if (dialogName === 'avg') {
      this.showAvgInfo = true;
    }

    this.productionInfo = [data];
  }

  onCloseModal(showModal: boolean) {}
}
